import React from 'react'
// @ts-ignore
import { sys } from '@netbasequid/theme'
// @ts-ignore
import { DefaultAvatar } from '@netbasequid/core'
import styled from 'styled-components'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import { AUTO_ATTR_KEY, AutomationId } from 'utils/automationUtil'
import { DateStyle, StyledContainer } from './index.css'

const StyledAvatarContainer = styled.div`
  opacity: 0.4;
`

const StyledContentContainer = styled.div`
  width: 100%;
  min-width: 0;
  display: flex;
`

const StyledDate = styled.div.attrs({
  [AUTO_ATTR_KEY]: AutomationId.soundbiteDefaultFrame.date
})`
  ${DateStyle}
  white-space: nowrap;
  min-width: 20px;

  display: inline-block;
  padding-right: 9px;
  flex: 0 5 fit-content;
`

const StyledContent = styled.div`
  flex: 1 1 fit-content;
  width: 100%;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: ${sys.typescale[14].lineHeight};
  font-size: ${sys.typescale[14].size};
  font-weight: 400;
  padding-left: 12px;
  padding-right: 12px;
  color: ${({ mode }: { mode: Theme }) => sys[mode].text.placeholder};
`

type CompactDeletedPostProps = {
  content: string | React.ReactElement
  date: string
  serialNumber: number
}

const CompactDeletedPost = ({ content, date, serialNumber }: CompactDeletedPostProps) => {
  const theme = useDisplayTheme() as Theme

  return (
    <StyledContainer
      mode={theme}
      data-testid={`${AutomationId.compactSoundbiteDefaultFrame.post}-${serialNumber}`}>
      <StyledAvatarContainer>
        <DefaultAvatar fontSize={32} mode={theme} />
      </StyledAvatarContainer>
      <StyledContentContainer>
        <StyledContent mode={theme}>{content}</StyledContent>
        <StyledDate mode={theme}>{date}</StyledDate>
      </StyledContentContainer>
    </StyledContainer>
  )
}

export default CompactDeletedPost
